import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { DataProvider } from './context/DataContext';
import { ToastProvider } from './context/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import Footer from './components/Footer';

// Lazy load all route components
const Home = lazy(() => import('./pages/Home'));
const CategoryPage = lazy(() => import('./pages/CategoryPage'));
const ProductDetails = lazy(() => import('./pages/ProductDetails'));
const ShopAll = lazy(() => import('./pages/ShopAll'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const NotFound = lazy(() => import('./pages/NotFound'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));

function App() {
  return (
    <HelmetProvider>
      <ToastProvider>
        <ErrorBoundary>
          <Router>
            <DataProvider>
          <div className="App">
          <Routes>
            {/* Admin Routes - No Header/Footer */}
            <Route path="/admin/login" element={
              <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '1.2rem' }}>Loading...</div>}>
                <AdminLogin />
              </Suspense>
            } />
            <Route path="/admin/dashboard" element={
              <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '1.2rem' }}>Loading Dashboard...</div>}>
                <AdminDashboard />
              </Suspense>
            } />
            
            {/* Public Routes - With Header/Footer */}
            <Route path="/*" element={
              <>
                <Header />
                <main style={{ minHeight: 'calc(100vh - 400px)' }}>
                  <Suspense fallback={
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center', 
                      height: '50vh', 
                      fontSize: '1.2rem',
                      color: '#666'
                    }}>
                      Loading page...
                    </div>
                  }>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/category/:categoryId" element={<CategoryPage />} />
                      <Route path="/product/:productId" element={<ProductDetails />} />
                      <Route path="/shop-all" element={<ShopAll />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </Suspense>
                </main>
                <Footer />
              </>
            } />
          </Routes>
            </div>
            </DataProvider>
          </Router>
        </ErrorBoundary>
      </ToastProvider>
    </HelmetProvider>
  );
}

export default App;
